/**
 * Dashboard widget cache/refresh sürelerinin tek noktası.
 * Saniye cinsinden. Backend ajanının önerdiği değerleri baz alır.
 *
 * Değiştirme rehberi:
 * - Düşürmek istiyorsanız (örn. cash_register'ı 30s yapın): aşağıdaki tablodan değeri değiştirin.
 * - Tüm dashboard'u sıkı tutmak için: DEFAULT_REFRESH_SECONDS'i düşürün.
 * - Bir widget için "manuel refresh dışında otomatik yenileme YAPMA" istiyorsanız: değeri 0 yapın.
 *
 * Cache TTL ve refresh interval şu an aynı değerden besleniyor:
 *   - Cache TTL: aynı widget'ı bu süre içinde tekrar isterseniz cache'ten döner.
 *   - Refresh interval: dashboard açıkken bu sürede bir background fetch.
 * İleride ayırmak gerekirse REFRESH_SECONDS'i CACHE_TTL_SECONDS'tan ayırın.
 */

export const REFRESH_SECONDS = {
    revenue: 90,
    expenses: 90,
    outstanding: 90,
    payables: 90,
    payment_methods: 90,
    cash_register: 90,

    stock: 120,
    low_stock: 120,

    sms_credit: 120,
    sms_credit_simple: 120,
    sms_titles: 120,

    agenda_upcoming: 90,
    agenda_stats: 90,

    work_order_recent: 60,
    work_order_status: 60,

    storage: 3600,
    storage_simple: 3600,
    subscriptions: 3600,
    subscription_summary: 3600,

    weather: 900,
};

export const DEFAULT_REFRESH_SECONDS = 120;

export function getRefreshSeconds(widgetId) {
    const v = REFRESH_SECONDS[widgetId];
    if (v === undefined || v === null) return DEFAULT_REFRESH_SECONDS;
    return v;
}

export function getRefreshMs(widgetId) {
    return getRefreshSeconds(widgetId) * 1000;
}
